// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "index" + "." + "68f43378138c3ca47449" + ".css";
};